export const ACTION_TYPE = 'actionType';
export const ACTION_TYPE_ID = 'actionTypeId';
export const URL = 'url';
export const APP_ID = 'appId';
export const AUTH_SETTINGS = 'authSettings';
export const METHOD = 'method';
export const OUTPUT_FIELDS = 'outputFields';
export const QUERY_PARAMS = 'queryParams';
export const VARIABLES = 'variables';
export const JSON_SCHEMA = 'jsonSchema';